import React from "react";
import "./Dashboard.css";
import DijonCard from "./DijonCard";
import LedgerPage from "../Ledger/LedgerPage";

function DijonLedger(props) {
  return (
    <div id="ledger-card">
      <DijonCard
        width={"90vw"}
        height={"90vh"}
        defaultX={0}
        activeCards={props.activeCards}
        setActiveCards={props.setActiveCards}
        name={"ledger"}
        content={
          <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
            <LedgerPage />
          </div>
        }
      />
    </div>
  );
}

export default DijonLedger;
